
import { css } from 'styled-components';

export const CssDebug = css`
  .debug {
    outline: 1px solid var(--color-danger-100);
  }
`;
